import {
  SET_SERVER_ERROR,
  SET_BUILDER_STATUS,
  SET_SETTINGS_SUBMENU_STATUS,
  SET_CURRENT_SEQUENCE_PAGE
} from "./types";
import actions from "./actions";
import { setter, getter } from "@/store/utils";
import { CHANGE_ITEMS_PER_PAGE } from "@/store/common/types";
import Vue from "vue";
import { getLastCompletedPageFromLS } from "@/utils/util";

const state = {
  hasError: false,
  builderLoaded: false,
  submenuOpened: true,
  itemsPerPage: 25,
  currentSequencePage: getLastCompletedPageFromLS() || 1
};

const getters = {
  submenuOpened: getter("submenuOpened"),
  itemsPerPage: getter("itemsPerPage"),
  currentSequencePage: getter("currentSequencePage")
};

const mutations = {
  [SET_SERVER_ERROR](state, { payload }) {
    setter("hasError", payload)(state);
  },

  [SET_BUILDER_STATUS](state, { payload }) {
    setter("builderLoaded", payload)(state);
  },

  [SET_SETTINGS_SUBMENU_STATUS](state, { payload }) {
    setter("submenuOpened", payload)(state);
  },

  [SET_CURRENT_SEQUENCE_PAGE](state, { payload }) {
    setter("currentSequencePage", payload)(state);
  },

  [CHANGE_ITEMS_PER_PAGE](state, { payload }) {
    Vue.set(state, "itemsPerPage", payload);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
